export const GET_VERIFICATION_DATA_REQUEST = 'verification/get/request';
export const GET_VERIFICATION_DATA_SUCCESS = 'verification/get/success';
export const GET_VERIFICATION_DATA_FAILURE = 'verification/get/failure';

export const SAVE_VERIFICATION_DATA_REQUEST = 'verification/save/request';
export const SAVE_VERIFICATION_DATA_SUCCESS = 'verification/save/success';
export const SAVE_VERIFICATION_DATA_FAILURE = 'verification/save/failure';
